import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, Button, Spinner } from 'react-bootstrap';

import Utils from '../../configs/Utils';
import Enums from '../../configs/Enums';
import { useAuth } from '../../contexts/AuthContext';

const AuthDrive = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setCurrentUser } = useAuth();
  const [status, setStatus] = useState('processing'); // processing | success | error
  const [errorMessage, setErrorMessage] = useState('');
  const ranOnce = useRef(false);

  useEffect(() => {
    // Strict-mode guard: chỉ chạy 1 lần. `code` chỉ dùng được 1 lần ở Google.
    if (ranOnce.current) return;
    ranOnce.current = true;

    const code = searchParams.get('code');
    const oauthError = searchParams.get('error');

    const finish = async () => {
      if (oauthError) {
        setStatus('error');
        setErrorMessage(`Google authorization was denied: ${oauthError}`);
        return;
      }

      if (!code) {
        setStatus('error');
        setErrorMessage('Missing authorization code from Google.');
        return;
      }

      const data = await Utils._apiRequest({
        path: Enums.endpoints.google.oauth2Callback,
        type: 'GET',
        query: { code },
      });

      if (data?.errors || data?.message || !data?.oath2Token) {
        setStatus('error');
        setErrorMessage(
          data?.errors?.message || data?.message || 'Failed to connect Google account.'
        );
        return;
      }

      // Refresh AuthContext để Settings page thấy ngay token mới mà không cần reload.
      try {
        const me = await Utils._apiRequest({
          path: Enums.endpoints.auth.ME,
          type: 'GET',
        });
        if (me && !me.errors) {
          setCurrentUser(me);
        }
      } catch (err) {
        console.warn('Refresh user after Google connect failed:', err);
      }

      setStatus('success');
      // Auto redirect sau 1.2s để user kịp thấy trạng thái success.
      setTimeout(() => navigate('/settings#google-sheet', { replace: true }), 1200);
    };

    finish();
  }, [navigate, searchParams, setCurrentUser]);

  return (
    <main className="main-page container mt-5">
      <h2>Connecting Google account…</h2>
      {status === 'processing' && (
        <div className="d-flex align-items-center mt-3">
          <Spinner animation="border" size="sm" className="me-2" />
          <span>Please wait while we finalize the connection.</span>
        </div>
      )}
      {status === 'success' && (
        <Alert variant="success" className="mt-3">
          Google account connected successfully. Redirecting…
        </Alert>
      )}
      {status === 'error' && (
        <>
          <Alert variant="danger" className="mt-3">
            {errorMessage}
          </Alert>
          <Button variant="primary" onClick={() => navigate('/settings#google-sheet', { replace: true })}>
            Back to Settings
          </Button>
        </>
      )}
    </main>
  );
};

export default AuthDrive;